// TODO: remove this component - have copied this same in the FadingGradient
// Check if this is not used elsewhere

import React from 'react';
import styles from './Gradient.module.css';

export const Gradient = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={className ? `${styles.gradient} ${className}` : styles.gradient}
    {...props}
  />
));
Gradient.displayName = 'Gradient';

export const GradientLeft = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={
      className ? `${styles.gradientLeft} ${className}` : styles.gradientLeft
    }
    {...props}
  />
));
GradientLeft.displayName = 'GradientLeft';
